import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import * as React from "react";
import { DARK_BLUE_COLOR } from "theme/variable";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: DARK_BLUE_COLOR,
    maxWidth: 318,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    border: "1px solid #dadde9",
    padding: 25,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#f5f5f9",
  },
}));

export default CustomTooltip;
